import DevoteamLanding from './DevoteamModule';

export default DevoteamLanding;
